// extracted by mini-css-extract-plugin
module.exports = {"button":"Download_button__1Y0aF","icon":"Download_icon__2Qlq5"};